import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "breadcrumb is-medium",
  "aria-label": "breadcrumbs"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Агенты")
const _hoisted_3 = { class: "is-active" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "page-header is-flex is-justify-content-space-between is-align-items-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-left" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "is-size-3 has-text-weight-medium" }, "Карточка агента")
  ])
], -1)
const _hoisted_7 = { class: "tabs" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Профиль", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Заказы", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Баланс", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "has-text-weight-bold" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Чат")
const _hoisted_16 = {
  key: 0,
  class: "badge ml-2"
}
const _hoisted_17 = {
  key: 1,
  class: "agent-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Balance = _resolveComponent("Balance")!
  const _component_Orders = _resolveComponent("Orders")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_Profile = _resolveComponent("Profile")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'busy': _ctx.ctx.isEntityLoading})
  }, [
    (!_ctx.ctx.isEntityLoading)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/agents" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_3, [
              _createElementVNode("a", null, _toDisplayString(_ctx.ctx.entity.passport.fullname), 1),
              _createElementVNode("span", {
                class: "icon",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args))),
                style: {"cursor":"pointer","font-size":"14px","margin-left":"0"},
                title: "Скопировать полное имя агента"
              }, _hoisted_5)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.PROFILE }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = _ctx.tabNames.PROFILE))
        }, _hoisted_9, 2),
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.ORDERS }),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = _ctx.tabNames.ORDERS))
        }, _hoisted_11, 2),
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.BALANCE }),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = _ctx.tabNames.BALANCE))
        }, _hoisted_13, 2),
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.CHAT }),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = _ctx.tabNames.CHAT))
        }, [
          _createElementVNode("a", _hoisted_14, [
            _hoisted_15,
            (_ctx.ctx.unreadMessagesCount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.ctx.unreadMessagesCount > 999 ? 999 : _ctx.ctx.unreadMessagesCount), 1))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ])
    ]),
    (!_ctx.ctx.isEntityLoading && _ctx.ctx.entity)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_ctx.tab === _ctx.tabNames.BALANCE)
            ? (_openBlock(), _createBlock(_component_Balance, {
                key: 0,
                agentId: _ctx.ctx.entity.general.id,
                mlmId: _ctx.ctx.entity.general.mlm_id
              }, null, 8, ["agentId", "mlmId"]))
            : (_ctx.tab === _ctx.tabNames.ORDERS)
              ? (_openBlock(), _createBlock(_component_Orders, {
                  key: 1,
                  agentId: _ctx.ctx.entity.general.id
                }, null, 8, ["agentId"]))
              : (_ctx.tab === _ctx.tabNames.CHAT)
                ? (_openBlock(), _createBlock(_component_Chat, {
                    key: 2,
                    agentId: _ctx.ctx.entity.general.id
                  }, null, 8, ["agentId"]))
                : (_openBlock(), _createBlock(_component_Profile, {
                    key: 3,
                    item: _ctx.ctx
                  }, null, 8, ["item"]))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}